import { api } from "@/lib/api";

/**
 * Shared map tile configuration. Provider + key are editable in admin (SEO tab).
 * Falls back to keyless OpenStreetMap when no key is configured.
 */
const TILES = {
  osm: {
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> prispievatelia',
  },
  carto_dark: {
    url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?api_key={key}",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
  },
  stadia_dark: {
    url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key={key}",
    attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
};

let cached = null;

export async function getTileConfig() {
  if (cached) return cached;
  try {
    const { data } = await api.get("/map-config");
    const t = TILES[data.provider] || TILES.osm;
    cached = { url: t.url.replace("{key}", data.key || ""), attribution: t.attribution };
  } catch {
    cached = TILES.osm;
  }
  return cached;
}

/** Reset cache (e.g. after admin changes the provider). */
export function resetTileConfig() {
  cached = null;
}
